import React from 'react'
import { GraniteDataGrid } from '@tecuity/granite-ui/GraniteDataGrid'
import { useSelector, shallowEqual } from 'react-redux'

const PrintReports = () => {
  const tableColumns = [
    {
      field: 'displayName',
      flex: 0.7,
      minWidth: 20,
      headerName: 'Report',
      disableColumnMenu: true,
    },
  ]

  const reports = useSelector((state) => state.postPayment.reports, shallowEqual)

  return (
    <React.Fragment>
      <GraniteDataGrid
        columns={tableColumns}
        rows={reports}
        pagination={undefined}
        rowsPerPageOptions={[25, 50, 100]}
        checkboxSelection={false}
      />
    </React.Fragment>
  )
}

export default PrintReports
